module.exports = __webpack_public_path__ + "img/1-1.171c71e2.jpg";